/* tslint:disable */
/* eslint-disable */
/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Location } from '../models';
/**
 * LocationsApi - axios parameter creator
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [city] 
         * @param {string} [state] 
         * @param {string} [postalCode] 
         * @param {number} [milesRadius] 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsGet: async (city?: string, state?: string, postalCode?: string, milesRadius?: number, locationId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (city !== undefined) {
                localVarQueryParameter['City'] = city;
            }

            if (state !== undefined) {
                localVarQueryParameter['State'] = state;
            }

            if (postalCode !== undefined) {
                localVarQueryParameter['PostalCode'] = postalCode;
            }

            if (milesRadius !== undefined) {
                localVarQueryParameter['MilesRadius'] = milesRadius;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['LocationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsLocationIdDelete: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiLocationsLocationIdDelete', 'locationId', locationId)
            const localVarPath = `/api/Locations/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationdId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsLocationdIdGet: async (locationdId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationdId' is not null or undefined
            assertParamExists('apiLocationsLocationdIdGet', 'locationdId', locationdId)
            const localVarPath = `/api/Locations/{locationdId}`
                .replace(`{${"locationdId"}}`, encodeURIComponent(String(locationdId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Location} [location] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsPost: async (location?: Location, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(location, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Location} [location] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsPut: async (location?: Location, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(location, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [city] 
         * @param {string} [state] 
         * @param {string} [postalCode] 
         * @param {number} [milesRadius] 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsGet(city?: string, state?: string, postalCode?: string, milesRadius?: number, locationId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLocationsGet(city, state, postalCode, milesRadius, locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsLocationIdDelete(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLocationsLocationIdDelete(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiLocationsLocationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationdId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsLocationdIdGet(locationdId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLocationsLocationdIdGet(locationdId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiLocationsLocationdIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Location} [location] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsPost(location?: Location, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLocationsPost(location, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Location} [location] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsPut(location?: Location, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLocationsPut(location, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiLocationsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * 
         * @param {LocationsApiApiLocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsGet(requestParameters: LocationsApiApiLocationsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiLocationsGet(requestParameters.city, requestParameters.state, requestParameters.postalCode, requestParameters.milesRadius, requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiLocationsLocationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsLocationIdDelete(requestParameters: LocationsApiApiLocationsLocationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiLocationsLocationIdDelete(requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiLocationsLocationdIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsLocationdIdGet(requestParameters: LocationsApiApiLocationsLocationdIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiLocationsLocationdIdGet(requestParameters.locationdId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiLocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsPost(requestParameters: LocationsApiApiLocationsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiLocationsPost(requestParameters.location, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiLocationsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsPut(requestParameters: LocationsApiApiLocationsPutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiLocationsPut(requestParameters.location, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiLocationsGet operation in LocationsApi.
 */
export interface LocationsApiApiLocationsGetRequest {
    readonly city?: string

    readonly state?: string

    readonly postalCode?: string

    readonly milesRadius?: number

    readonly locationId?: string
}

/**
 * Request parameters for apiLocationsLocationIdDelete operation in LocationsApi.
 */
export interface LocationsApiApiLocationsLocationIdDeleteRequest {
    readonly locationId: string
}

/**
 * Request parameters for apiLocationsLocationdIdGet operation in LocationsApi.
 */
export interface LocationsApiApiLocationsLocationdIdGetRequest {
    readonly locationdId: string
}

/**
 * Request parameters for apiLocationsPost operation in LocationsApi.
 */
export interface LocationsApiApiLocationsPostRequest {
    readonly location?: Location
}

/**
 * Request parameters for apiLocationsPut operation in LocationsApi.
 */
export interface LocationsApiApiLocationsPutRequest {
    readonly location?: Location
}

/**
 * LocationsApi - object-oriented interface
 */
export class LocationsApi extends BaseAPI {
    /**
     * 
     * @param {LocationsApiApiLocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLocationsGet(requestParameters: LocationsApiApiLocationsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiLocationsGet(requestParameters.city, requestParameters.state, requestParameters.postalCode, requestParameters.milesRadius, requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiLocationsLocationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLocationsLocationIdDelete(requestParameters: LocationsApiApiLocationsLocationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiLocationsLocationIdDelete(requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiLocationsLocationdIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLocationsLocationdIdGet(requestParameters: LocationsApiApiLocationsLocationdIdGetRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiLocationsLocationdIdGet(requestParameters.locationdId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiLocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLocationsPost(requestParameters: LocationsApiApiLocationsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiLocationsPost(requestParameters.location, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiLocationsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLocationsPut(requestParameters: LocationsApiApiLocationsPutRequest = {}, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiLocationsPut(requestParameters.location, options).then((request) => request(this.axios, this.basePath));
    }
}

